"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRgbColor = void 0;
const assertString_1 = require("./util/assertString");
const rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
const rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
const rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)/;
const rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)/;
function isRgbColor(str, includePercentValues = true) {
    (0, assertString_1.assertString)(str);
    if (!includePercentValues) {
        return rgbColor.test(str) || rgbaColor.test(str);
    }
    return rgbColor.test(str) ||
        rgbaColor.test(str) ||
        rgbColorPercent.test(str) ||
        rgbaColorPercent.test(str);
}
exports.isRgbColor = isRgbColor;
